import React, { useState, useEffect } from "react";
import axios from "axios";

const FileUpload = () => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");
    const [progress, setProgress] = useState({ sentCount: 0, totalEmails: 0 });
    const [failedEmails, setFailedEmails] = useState([]);

    const BASE_URL = "https://bootcamp-registration.onrender.com";
    // const BASE_URL = "http://localhost:8000";

    useEffect(() => {
        fetchFailedEmails();
    }, []);

    const fetchFailedEmails = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/failed-emails`);
            setFailedEmails(response.data);
        } catch (error) {
            console.error("Error fetching failed emails:", error);
        }
    };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) {
            setMessage("Please select a file");
            return;
        }

        setMessage("Uploading... Please wait.");

        const eventSource = new EventSource(`${BASE_URL}/progress`);
        eventSource.onmessage = (event) => {
            const data = JSON.parse(event.data);
            setProgress(data);

            if (data.sentCount === data.totalEmails) {
                eventSource.close();
                setMessage("All emails sent!");
            }
        };

        try {
            const formData = new FormData();
            formData.append("file", file);

            setMessage("Emails are being sent!");

            const result = await axios.post(`${BASE_URL}/upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            setMessage(result.data.message)
        } catch (error) {
            eventSource.close();
            setMessage("Error uploading file");
        }
    };


    const retryFailedEmails = async () => {
        try {
            await axios.post(`${BASE_URL}/retry-failed`);
            setMessage("Retrying failed emails...");
            fetchFailedEmails();
        } catch (error) {
            setMessage("Error retrying failed emails");
        }
    };

    return (
        <div className="container mx-auto p-6 bg-gray-100 min-h-screen">
            <div className="p-6 max-w-lg mx-auto bg-white rounded-lg shadow-md">
                <h2 className="text-xl font-semibold">Upload Excel File</h2>
                <input type="file" onChange={handleFileChange} className="mt-4" />
                <button
                    onClick={handleUpload}
                    className="mt-4 bg-[#F20034] text-white px-4 py-2 rounded"
                >
                    Upload & Send Emails
                </button>

                {message && <p className="mt-4 text-gray-700">{message}</p>}

                {progress.totalEmails > 0 && (
                    <div className="mt-4">
                        <p>Progress: {progress.sentCount}/{progress.totalEmails}</p>
                        <div className="w-full bg-gray-300 h-4 rounded">
                            <div
                                className="bg-green-500 h-4 rounded"
                                style={{ width: `${(progress.sentCount / progress.totalEmails) * 100}%` }}
                            ></div>
                        </div>
                    </div>
                )}

                {failedEmails.length > 0 && (
                    <div className="mt-4">
                        <p className="text-red-500">Failed Emails: {failedEmails.length}</p>
                        <button onClick={retryFailedEmails} className="bg-red-500 text-white px-4 py-2 rounded">
                            Retry Failed Emails
                        </button>
                    </div>
                )}
            </div>
        </div>

    );
};

export default FileUpload;
